module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-center"
  }, [(_vm.$route.name !== 'payment') ? _c('button', {
    staticClass: "btn-quantity",
    style: (("color:" + (_vm.globalColors.primary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-sub')
      }
    }
  }, [_vm._v("\n\t\t\t-\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.quantity))]), _vm._v(" "), (_vm.$route.name !== 'payment') ? _c('button', {
    staticClass: "btn-quantity",
    style: (("color:" + (_vm.globalColors.primary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-add')
      }
    }
  }, [_vm._v("\n\t\t\t+\n\t\t")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3990d2bc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttonQuantity.vue
// module id = 1096
// module chunks = 36